import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostRedemptionApplicationList(params) {
  return request(
    `${BASE_URL}/provider/redemption/application/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostRedemptionApplicationcount(params) {
  return request(
    `${BASE_URL}/provider/redemption/application/count`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostRedemptionApplication(params) {
  return request(`${BASE_URL}/provider/redemption/application`, METHOD.POST_JSON_ENCRYPT, params)
}

export async function rqtPutRedemptionApplication(id, params) {
  return request(`${BASE_URL}/provider/redemption/application/${id}`, METHOD.PUT_JSON_ENCRYPT, params)
}

export async function rqtPutRedemptionApplicationCancel(params) {
  return request(`${BASE_URL}/provider/redemption/application`, METHOD.PUT_JSON_ENCRYPT, params)
}